import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const survey_endpoints = APIS_ENDPOINTS.answersurvey

export const request_getallsurvey = async (surveyCategoryId: number) => {
  return http.get(survey_endpoints.getallsurvey + `?SurveyCategoryId=${surveyCategoryId}`)
}
